'use es6';

export const getLocation = state => state.routing.locationBeforeTransitions;
export const getPathname = () => {
  return window.location.pathname;
};
export const getHighlightedLinesFromLocation = location => {
  const {
    hash
  } = location;
  const [, editorSide, hashFrom, hashTo] = hash.match(/^#(L|R)(\d+)(?:-\1(\d+))?$/) || [];
  const from = hashFrom && Number(hashFrom);
  const to = hashTo && Number(hashTo);
  return {
    editorSide,
    from,
    to
  };
};